module.exports = __webpack_public_path__ + "media/components/src/assets/images/block_image_1-5fcde07a556c05b455365148f4026312.jpg";